import { createContext } from 'react';
import { RestUser, UserPreferences } from '../schema-copy/api-schema';
import { AuthData } from '../connector/auth';
import { FeedEngine } from '../connector/feed-engine';

type LoginState = 'ok' | 'unconfirmed' | 'reloginRequired' | 'loggedOut';

export interface GeneralState {
  loginState: LoginState;

  authData?: AuthData
  currentUser?: RestUser;
  userPreferences: UserPreferences;
}

export interface AppContext {
  state: GeneralState;
  feedEngine: FeedEngine;
  setUnconfirmed: (authData: AuthData) => void;
  setLoggedIn: (authData: AuthData, user: RestUser) => void;
  setReloginRequired: () => void;
  setLoggedOut: () => void;
  setUserPreferences: (prefs: UserPreferences) => void;
}

export const AppState = createContext<AppContext>({} as AppContext);

